import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Accordion, Card, Button, Form } from 'react-bootstrap';
import { gather_source, ReportPlot } from './Javascript/GenerateReport.js';
import * as RO from './Javascript/ReportObjects.js';
import * as IN from './Javascript/IncidentsReport.js';
import * as G from './Javascript/General.js';
import RouteIncidents from './RouteIncidents';
import MapComponent from './MapComponent';
import './CSS/Bootstrap/bootstrap.css';
import Plot from 'react-plotly.js';
import './CSS/style.css';

interface Props {
  map_ref: any;
}

const SingleIncidentReport: React.FC<Props> = ({ map_ref }) => {
    const [is_loading, set_is_loading] = useState(true);
    const [are_ids_valid, set_are_ids_valid] = useState(true);
    const [are_classes_valid, set_are_classes_valid] = useState(true);
    const [incidentUuids, setIncidentUuids] = useState<string[]>([]);
    const [incidentParameters, setIncidentParameters] = useState<RO.ReportPageParameters | null>(null);
    const [incident, setIncident] = useState<RO.RouteIncident | null>(null);
    const [incidentMarkers, setIncidentMarkers] = useState<RO.Location[] | null>(null);
    const [incidentTitle, setIncidentTitle] = useState<String>("");
    const [incidentCoords, setIncidentCoords] = useState<String[]>([]);
    const [mapKey, setMapKey] = useState(Date.now());

    const call_generate_pdf = async ( dl_type: string) => {
          let title_cont = document.querySelectorAll(".incident_total_cont");

          title_cont.forEach(function(cont) {
              let titlesToRemove = cont.querySelectorAll(".sub_title");
              titlesToRemove.forEach(function(title) {
                  title.remove();
              });
          });

          if (are_ids_valid && are_classes_valid) {
              G.setPagePortrait(true);
              gather_source([], [], "", map_ref, true);
              if(dl_type == 'pdf') gather_source([], [], "download_pdf", map_ref, true);
              else if(dl_type == 'word') gather_source([], [], "download_word", map_ref, true);
              else if(dl_type == 'excel') gather_source([], [], "download_excel", map_ref, true);
          }
      };

    useEffect(() => {
        if(!is_loading){
            var download_btn = document.getElementById("download_pdf_btn") as HTMLButtonElement;
            if(download_btn){
                download_btn.disabled = false;
                download_btn.addEventListener('click', () => call_generate_pdf('pdf'));
            }
        }
    }, [is_loading]);

    const reloadMap = () => {
        window.location.reload();
    };

    useEffect(() => {
        const fetchDetails = async () => {
            try{
                if(incident == null) {
                    let res = await IN.assignStatusAndWeaponIncident(await IN.getIncidents([RO.template_uuid]));
                    res[0].incident_coordinates = G.populateLocation(res[0].incident_coordinates);
                    if(res != null) setIncident(res[0]);
                }
                if(incident != null && incidentMarkers == null) setIncidentMarkers([incident.incident_coordinates]);
            } catch (error) {
                console.error(error);
            } finally {
                if (incident !== null && incidentMarkers != null) set_is_loading(false);
            }
        }
        fetchDetails();
    }, [incidentUuids, incident, incidentMarkers]);

    useEffect(() => {
        if(incident) {
            if(RO.coord_format === "DDM" && incident.incident_coordinates.Ddm?.LonString !== undefined &&
                incident.incident_coordinates.Ddm?.LatString !== undefined){
                setIncidentCoords([incident.incident_coordinates.Ddm?.LonString, incident.incident_coordinates.Ddm?.LatString]);
            }
            else if(RO.coord_format === "DMS" && incident.incident_coordinates.Dms?.LonString !== undefined &&
                incident.incident_coordinates.Dms?.LatString !== undefined){
                setIncidentCoords([incident.incident_coordinates.Dms?.LonString, incident.incident_coordinates.Dms?.LatString]);
            }
            else{
                setIncidentCoords([incident.incident_coordinates.dec.lon.toString(), incident.incident_coordinates.dec.lat.toString()]);
            }
        }
    }, [incident]);

    return (
    <div id="single_incident_container">
       {is_loading || incident == null ? (
            <div id="loading">Loading...<span className="rotating-arrows">&#8635;</span></div>
       ) : (
       <>
            <div id="top_btn_panel">
                <button type="button" id="download_pdf_btn" disabled> Download PDF </button>
                <button style={{display:'none'}} type="button" onClick={() => call_generate_pdf('word')}> Download Word </button>
                <button style={{display:'none'}} type="button" onClick={() => call_generate_pdf('excel')}> Download excel </button>
                <div className="top_menu_item">
                    <button type="button" className="button_style" onClick={reloadMap}>Reload Report</button>
                </div>
            </div>
            <h1 style={{display:'none'}} id="report_title">{G.displayValue(incident?.external_ref)}</h1>
            <div  className="report_row singleIncident_row" >
                <div id="enforce_page1_div1_height">
                    <div className="inner_padding">
                        <p className="sub_title">Incident</p>
                        <table className="singleIncident_table">
                        <tbody>
                            <tr>
                                <td><span className="title">Latitude</span> <br /> { G.displayValue(incidentCoords[1]) }</td>
                                <td><span className="title">Longitude</span> <br /> { G.displayValue(incidentCoords[0]) }</td>
                                <td><span className="title">UTC Date/Time</span> <br /> { G.displayValue(incident?.utc_date_time.replace("T", " ")) }</td>
                                <td><span className="title">Local Date/Time</span> <br /> { G.displayValue(incident?.local_date_time.replace("T", " ")) }</td>
                            </tr>
                            <tr>
                                <td><span className="title">Status</span> <br /> { G.displayValue(incident?.incident_status) }</td>
                                <td><span className="title">Location</span> <br /> { G.displayValue(incident?.sea) }</td>
                                <td><span className="title">Weapons</span> <br /> { G.displayValue(incident?.incident_weapons) }</td>
                                <td><span className="title">Local Time of Day</span> <br /> { G.displayValue(IN.getTimeOfDayCategory(incident.time_of_day)) }</td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div id="incident_report_table"  className="report_row singleIncident_row" >
                <div id="enforce_page2_div2_height">
                    <div className="inner_padding">
                        <p className="sub_title">Victim</p>
                        <table className="singleIncident_table">
                        <tbody>
                            <tr>
                                <td><span className="title">Name</span> <br /> { G.displayValue(incident?.victim_vessel_name)}</td>
                                <td><span className="title">Type</span> <br /> { G.displayValue(incident?.victim_vessel_type)}</td>
                                <td><span className="title">Status</span> <br /> { G.displayValue(incident?.victim_vessel_status)}</td>
                                <td><span className="title">Flag</span> <br /> { G.displayValue(incident?.victim_vessel_flag.name)}</td>
                            </tr>
                            <tr>
                                <td><span className="title">IMO</span> <br /> { G.displayValue(incident?.victim_vessel_imo)}</td>
                                <td><span className="title">MMSI</span> <br /> { G.displayValue(incident?.victim_vessel_mmsi)}</td>
                                <td><span className="title">Gross Tonnage</span> <br /> { G.displayValue(incident?.victim_vessel_gross_tonnage)}</td>
                                <td><span className="title">Size (m)</span> <br /> { (incident?.victim_vessel_beam * incident?.victim_vessel_length_overall)?.toString() + "m\u00B2" ?? 'UNKNOWN'}</td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div id="incident_report_table"  className="report_row singleIncident_row" >
                <div className="inner_padding">
                    <p className="sub_title">Aggressor</p>
                    <table className="singleIncident_table">
                    <tbody>
                        <tr>
                            <td><span className="title">Count of People</span> <br /> { G.displayValue(incident?.attacker_count?.toString())}</td>
                            <td><span className="title">Attacking Vessel(s)</span> <br /> { G.displayValue(incident?.pirate_vessel_description)}</td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <div className="clear_both"></div>
            </div>

            <div  className="report_row singleIncident_row" >
                {incidentMarkers != null ? (
                    <div id="single_incident_map_cont">
                        <MapComponent key={mapKey} report_data={null} map_ref={map_ref} markers={incidentMarkers}/>
                    </div>
                ) : (null)}
                <div className="clear_both"></div>
            </div>

            <div id="incident_report_table"  className="report_row singleIncident_row" >
                <div className="inner_padding">
                    <p className="sub_title">Narration</p>
                    <p className="narration_text text">{ G.displayValue(incident?.narration) }</p>
                    <p className="source_text text">Source: { G.displayValue(incident?.source) } <br /> MariTrace Security Incident - { G.displayValue(incident?.external_ref) }</p>
                </div>
                <div className="clear_both"></div>
            </div>
       </>
       )}
    </div>
)};
export default SingleIncidentReport;